import { browserHistory } from 'common/routing/browser_history';

export const getQueryValue = (key: string): string => {
    const search = new URLSearchParams(browserHistory.location?.search);
    const value = search.get(key);

    return value ? decodeURIComponent(value) : null;
};

export const setQueryValue = (key: string, value: string): void => {
    const search = new URLSearchParams(browserHistory.location?.search);
    const encodedValue = value ? encodeURIComponent(value) : '';
    if (search.get(key)) {
        search.set(key, encodedValue);
    } else {
        search.append(key, encodedValue);
    }

    const s = search.toString();
    // eslint-disable-next-line lodash/prefer-lodash-method
    browserHistory.replace(s[0] === '?' ? s : `?${s}`);
};
